import React from 'react';

import logo from '../../assets/logo.svg';

import './SplashScreen.css';

function SplashScreen() {
    return (
        <div className="splash-screen">
            <img src={logo} alt="logo" />
            <h1 className="kalam">Wordy Goals</h1>
        </div>
    );
}

export default SplashScreen;



// WEBPACK FOOTER //
// ./src/components/widgets/SplashScreen.js